import { fmt, fmtDate } from '@dcc-erp/shared';
import type { BankStatementListRow } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

import { num } from './recon-helpers';

function periodOf(d: Date | string): string {
  const dt = new Date(d);
  return `${String(dt.getMonth() + 1).padStart(2, '0')}/${dt.getFullYear()}`;
}

export function ReconHistory({ rows }: { rows: BankStatementListRow[] }) {
  return (
    <div className="tbl-shell">
      <div className="filter-row">
        <span style={{ fontSize: 14, fontWeight: 600 }}>ประวัติการปิดงวดกระทบยอดธนาคาร</span>
        <div style={{ marginLeft: 'auto' }}>
          <button className="btn sm" disabled title="เฟสถัดไป">
            <Icon name="download" size={12} /> Export
          </button>
        </div>
      </div>
      <table className="tbl">
        <thead>
          <tr>
            <th>งวด</th>
            <th>วันที่ปิด</th>
            <th>บัญชี</th>
            <th className="num">ยอดปิด</th>
            <th>สถานะ</th>
            <th>ผู้ปิดงวด</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={6} className="muted" style={{ padding: 32, textAlign: 'center' }}>
                ยังไม่มีงวดที่ปิดกระทบยอด
              </td>
            </tr>
          )}
          {rows.map((r) => (
            <tr key={r.id}>
              <td>
                <b>{periodOf(r.statementDate)}</b>
              </td>
              <td>{r.finalizedAt ? fmtDate(r.finalizedAt) : '—'}</td>
              <td>{r.bankAccountName}</td>
              <td className="num tnum">{fmt(num(r.closingBalance))}</td>
              <td>
                <span className="badge positive">
                  <Icon name="check" size={10} /> Reconciled · Locked
                </span>
              </td>
              <td className="muted">{r.finalizedBy ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
